import React from 'react';
import { Link } from 'react-router-dom';
import documentIntroIcon from '@/assets/images/documentIntroIcon.jpg';
import { getPropertyAddress } from '@/utils/properties';

const DocumentsPageIntro = ({
  propertyDocumentStatistics,
  getPropertyByBoligmappaNumber,
}) => {
  if (!propertyDocumentStatistics) return null;
  return (
    <div>
      <h3 className="text-xl font-medium mb-2">Dokumenter</h3>
      <div className="flex flex-col items-center w-full justify-center text-center rounded border bg-white p-4 md:p-[45px]">
        <img
          src={documentIntroIcon}
          alt="Document Intro"
          className="mb-6 w-[79px]"
        />
        {propertyDocumentStatistics.map((stat) =>
          stat.totalDocumentCount > 0 ? (
            <span
              key={stat.boligmappaNumber}
              className="text-base md:text-[22px]"
            >
              {getPropertyAddress(
                getPropertyByBoligmappaNumber(stat.boligmappaNumber)
              )}
              <span> har </span>
              <Link
                className=" underline"
                to={`/dashboard/${stat.boligmappaNumber}/documents`}
              >
                <b>{stat.totalDocumentCount || 0} dokumenter</b>
              </Link>
            </span>
          ) : (
            <span
              key={stat.boligmappaNumber}
              className="text-base md:text-[22px]"
            >
              {getPropertyAddress(
                getPropertyByBoligmappaNumber(stat.boligmappaNumber)
              )}
              <span> har ingen </span>
              <Link
                className=" underline"
                to={`/dashboard/${stat.boligmappaNumber}/documents`}
              >
                dokumenter
              </Link>{' '}
              ennå
            </span>
          )
        )}
      </div>
    </div>
  );
};

export default DocumentsPageIntro;
